<template>
    <div class="notification-menu-inbox py-3 d-flex gap-3" @click="openMessage()">


            <div class="thumb-container">
                <div class="thumb" :style="`background: url(${thumb});`">
                </div>
            </div>

            <div class="flex-grow-1">
                <div class="title-container">
                    <span>{{ title }}</span>
                </div>

                <div class="d-flex message">
                    <span>{{ message }}</span>
                </div>

            </div>

            <div class="counter-container">
                <span v-if="unreadCount > 0"
                      :class="{'counter-greater-ten': unreadCount+10 >= 10}"
                      class="notifications-count">
                    {{ unreadCount+10 }}
                </span>
            </div>


    </div>
</template>

<script>

let emitter = require('tiny-emitter/instance');

export default {
    name: "MenuInbox",
    props: {
        data: [],
    },
    data() {
        return {
            is_group: null,
            group: null,
            user: null,
            inbox: null,
            title: '',
            thumb: '',
            message: '',
            unreadCount: 0
        }
    },
    beforeMount(){

        let vm = this;

        console.log('####data => ', vm.data);

        vm.is_group     = vm.data.is_group;
        vm.group        = vm.data.group;
        vm.user         = vm.data.user;
        vm.inbox        = vm.data.inbox;
        vm.unreadCount  = vm.data.inbox.unread;

        vm.title    = vm.data.user.name;
        vm.thumb    = vm.data.user.avatar;
        vm.message  = vm.data.inbox.last_message;

        if(vm.is_group) {

            vm.title    = vm.data.group.name;
            vm.thumb    = vm.data.group.thumbnail ? vm.data.group.thumbnail : 'https://ui-avatars.com/api/?name=' + vm.data.group.name.substring(0, 2) + '&color=#f00&background=#000';

            vm.message  = vm.data.inbox.last_message;
            if(vm.user.id !== null) {
                vm.message  = vm.data.user.name +': '+ vm.data.inbox.last_message;
            }
        }
    },
    mounted() {

    },
    methods: {
        openMessage() {

            let payload = {
                "title"         : this.title,
                "thumb"         : this.thumb,
                "isGroup"       : this.is_group,
                "recipientId"   : (this.data.is_group) ? this.data.group.id : this.data.user.id
            };

            emitter.emit('MenuInbox::message::open', payload);
        }
    }
}

</script>

<style scoped lang="scss">

.notification-menu-inbox {

    flex-grow: 1;
    cursor: default;
    border-bottom: 1px solid #E1E1E1;

    &:hover {
        background-color: #F9F9F9;
    }

    .thumb-container {
        .thumb {

            width: 48px;
            height: 49px;
            border-radius: 54px;
            position: relative;
            background-size: cover !important;
            background-position: center !important;
            background-repeat: no-repeat !important;
            background-blend-mode: saturation;

        }
    }

    .title-container {
        span {
            font-family: Open Sans, sans-serif;
            font-size: 14px;
            font-weight: 600;
            line-height: 24px;
            color: #393939 !important;
        }
    }

    .message {
        span {
            font-family: Open Sans, sans-serif;
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            color: #393939 !important;
        }
    }

    .counter-container {
        .notifications-count {
            color: #FFFFFF;
            background-color: var(--buttons_color) !important;
            border-radius: 50%;
            padding: 3px 6px;
            font-size: 14px;
            font-weight: 700;
            line-height: 16px;
            margin-left: 10px;

            &.counter-greater-ten {
                line-height: 21px;
                padding: 5px 6px;
            }
        }
    }


    /* Apagar abaixo? */
    .done {
        cursor: pointer;
        color: var(--buttons_color);
        font-size: 25px;
        position: relative;

        &:before {
            content: "";
            position: absolute;
            top: -10px;
            bottom: -10px;
            left: -10px;
            right: -10px;
        }
    }

    .notification-icon {
        width: 140px;
        height: 89px;
        flex-shrink: 0;
        border-radius: 10px;
        background: #F6F6F6;


    }

    .notification-text {


        .title {
            color: var(--buttons_color);
            font-family: "Hanken Grotesk", sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            display: flex;
            align-items: center;

        }

        .author {
            font-family: "Open Sans", sans-serif;
            font-size: 1rem;
            font-weight: 600;
            line-height: 19px;
            color: #11BF03 !important;
            margin-left: 5px !important;
        }

        .description {
            font-family: "Open Sans", sans-serif;
            font-weight: 400;
            font-size: 0.95rem !important;
            line-height: 19px;
            color: #393939 !important;
        }

        .thumb {

            width: 48px;
            height: 49px;
            border-radius: 54px;
            position: relative;
            background-size: cover !important;
            background-position: center !important;
            background-repeat: no-repeat !important;
            background-blend-mode: saturation;

        }

        .icon-container {
            width: 49px;
            height: 49px;
            flex-shrink: 0;
            border-radius: 54px;
            position: relative;
            background-color: #F0F0F0;

            .material-symbols-outlined {
                color: #FFFFFF !important;
            }

        }

    }

    &.pendent {
        background-color: #00C4FF1F;

        &:hover {
            background-color: #F9F9F9;
        }
    }

    &.viewed {
        background-color: #FFFFFF;


        &:hover {
            background-color: #F9F9F9;
        }
    }

    &.new-notification {
        background-color: pink;
    }


    .material-symbols-outlined {
        font-variation-settings:
            'FILL' 1,
            'wght' 400,
            'GRAD' 0,
            'opsz' 24
    }



}




</style>